module.exports = __webpack_public_path__ + "img/send_notification_sendmagic.7b98dfd4.png";